import { MutationFunction } from "@apollo/client";
import downloadIcon from "@assets/images/download-teal.svg";
import { Button } from "@material-ui/core";
import {
  ExportCustomerMaterialTemplateMutation,
  ExportCustomerMaterialTemplateMutationVariables
} from "@saleor/graphql";
import React, { FC } from "react";
import InlineSVG from "react-inlinesvg";

import useStyles from "./styles";

interface CustomerMaterialProps {
  onDownloadPdf: MutationFunction<
    ExportCustomerMaterialTemplateMutation,
    ExportCustomerMaterialTemplateMutationVariables
  >;
}

const DownloadExcelTemplate: FC<CustomerMaterialProps> = ({
  onDownloadPdf
}) => {
  const classes = useStyles();

  const handleDownloadFile = async () => {
    try {
      const { data } = await onDownloadPdf({
        variables: {}
      });
      const link = document.getElementById(
        "download-template"
      ) as HTMLAnchorElement;
      const contentType =
        data?.exportCustomerMaterialTemplate?.contentType ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      link.href = `data:${contentType};base64,${data?.exportCustomerMaterialTemplate?.exportedFileBase64}`;
      link.target = "_self";
      link.download = data?.exportCustomerMaterialTemplate?.fileName;
      link.click();
    } catch (error) {
      console.error("Error while downloading file:", error);
    }
  };
  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        className={classes.btnMain}
        onClick={handleDownloadFile}
        startIcon={<InlineSVG src={downloadIcon} />}
        id="downloadExcelTemplate"
        name="downloadExcelTemplate"
      >
        <span> Download Excel Template </span>
      </Button>
      <a id="download-template" download>
        &nbsp;
      </a>
    </>
  );
};

export default DownloadExcelTemplate;
